import { User } from './user.type'
import { Arena } from './arena.type'
import { Rooster } from './rooster.type'

/**
 * สถานะของการแข่งขันไก่ชน
 */
export enum RoosterMatchStatus {
  OPEN = 'OPEN', // เปิดรับคู่แข่ง
  PENDING_APPROVAL = 'PENDING_APPROVAL', // รอการอนุมัติจาก admin
  APPROVED = 'APPROVED', // อนุมัติแล้ว
  REJECTED = 'REJECTED', // ปฏิเสธ
  CANCELLED = 'CANCELLED', // ยกเลิก
  COMPLETED = 'COMPLETED', // เสร็จสิ้น
  IN_PROGRESS = 'IN_PROGRESS', // กำลังแข่งขัน
}

/**
 * Interface สำหรับเก็บข้อมูลการแข่งขันไก่ชน
 */
export type RoosterMatch = {
  /** รหัสของการแข่งขัน */
  id: string

  /** หมายเลขการแข่งขัน */
  matchNumber: string

  /** รหัสไก่คนสร้าง match (ไก่เจ้าบ้าน) */
  rooster1Id: string

  /** รหัสไก่คู่เทียบ (ไก่แขก) */
  rooster2Id?: string

  /** รหัสเจ้าของไก่คนสร้าง match */
  ownerRooster1Id: string

  /** รหัสเจ้าของไก่คู่เทียบ */
  ownerRooster2Id?: string

  /** สนามจัดแข่งขัน */
  arenaId: string

  /** ราคาเดิมพันต่ำสุดที่ต้องการ */
  minBetAmount: number

  /** ราคาเดิมพันสูงสุดที่ต้องการ */
  maxBetAmount: number

  /** ราคาเดิมพันจริงที่ตกลงกัน */
  actualBetAmount?: number

  /** วันที่แข่งขัน */
  matchDate: Date

  /** สถานะการแข่งขัน */
  status: RoosterMatchStatus

  /** หมายเหตุเพิ่มเติม */
  note?: string

  /** วันที่สร้าง */
  createdAt: Date

  /** วันที่อัปเดตล่าสุด */
  updatedAt: Date

  // relation
  rooster1?: Rooster
  rooster2?: Rooster
  ownerRooster1?: User
  ownerRooster2?: User
  arena?: Arena
}
